import {h} from "preact";
import {GlobalsContext} from "../../AppContext";
import {useContext} from "preact/hooks";
import style from './HelpButton.css';
import clsx from "clsx";

const HelpButton = () => {
    const { setWidgetOpen, widgetOpen, setTooltipClose } = useContext(GlobalsContext);

    const handleClick = () => {
        setWidgetOpen(!widgetOpen);
        setTooltipClose(true);
    };

    return (
        <div
            className={clsx(style.root)}
            onClick={handleClick}
        ></div>
    );
};

export default HelpButton;
